module.exports = __webpack_public_path__ + "2_logo_rovcanin_jewellry_price_tag_mock_up_old.jpg?dbc672bd91f11f034da02a83a83086a1";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/rvcnn/2_logo_rovcanin_jewellry_price_tag_mock_up_old.jpg
// module id = 88
// module chunks = 0